import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_limit_the_use_of_fixedterm_contracts'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_limit_the_use_of_fixedterm_contracts',
  name: 'Does the facility limit the use of fixed-term contracts?',
  description:
    'The intent of this question is to understand if the facility places limits on the use of fixed-term contracts. \r\r\n\r\r\nFor example, the facility may limit the total duration of successive fixed-term contracts (e.g. no more than 4 years total).\r\r\n\r\r\nOr as another example, the facility might put a limit on the number of successive fixed-term contracts (e.g., 5 fixed-term contracts after another) before the worker becomes a permanent worker.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-3--8',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6160,
  sectionId: '2.2.4',
  impactArea: 'Contracts and HR',
  impactAreaId: 'CONTRACTS_AND_TERMS_OF_EMPLOYMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
